(() => {
  if (customElements.get('cg-concierge')) return;

  const FALLBACK_S2M = {
    formFields: [
      { id: 's2m-customerFirstName', inputAutocomplete: 'given-name', inputType: 'text', label: 'First name', required: true, type: 'customerFirstName', width: '50%' },
      { id: 's2m-customerLastName', inputAutocomplete: 'family-name', inputType: 'text', label: 'Last name', required: true, type: 'customerLastName', width: '50%' },
      { id: 's2m-customerEmail', inputAutocomplete: 'email', inputType: 'email', label: 'Email', required: true, type: 'email', width: '50%' },
      { id: 'ebc074a0-187c-468f-890f-5a9ae1a72338', inputType: 'date', label: 'Date that gifts need to arrive', required: true, type: 'date', width: '100%' },
      { id: 'e7324763-e723-489c-8532-3fbfbbd2c903', inputType: 'text', label: 'What items are you interested in for gifting?', required: false, type: 'text', width: '100%' },
      { id: 's2m-import-file-input', allowAnyFile: true, label: 'If multiple recipient addresses - please download this CSV and fill out - and drop below.', required: false, type: 'import', width: '100%' },
      { id: 's2m-customerPhone', inputAutocomplete: 'tel', inputType: 'tel', label: 'Phone', required: false, type: 'phone', width: '50%' },
      { id: 's2m-customerCompany', inputAutocomplete: 'off', inputType: 'text', label: 'Company', required: false, type: 'text', width: '50%' },
      { id: 's2m-howDidYouHearAboutUs', inputAutocomplete: 'off', inputType: 'text', label: 'How did you hear about us?', required: false, type: 'text', width: '50%' },
      {
        id: 's2m-occasion',
        label: 'Occasion',
        options: [
          { id: '2d2c2fce-41f8-4e8f-89ff-b82c46a9fb59', label: 'Birthday' },
          { id: '6ea1edb9-3e1e-4110-8bea-b922adb409ca', label: 'Anniversary' },
          { id: '6d16fe87-e983-4180-bc7a-f523a9339d00', label: 'Other' }
        ],
        required: false,
        type: 'dropdown',
        width: '50%'
      },
      { id: 's2m-message', label: 'Gift Message for Handwritten Note on Pappy Co card stock ($5 per note)', required: false, type: 'textarea', width: '100%' }
    ],
    importFormat: {
      id: '169',
      name: 'US samples',
      headers: [
        { raw: 'name', title: 'Full name', value: 'fullName' },
        { raw: 'email', title: 'Email', value: 'email' },
        { raw: 'phone', title: 'Phone', value: 'phone' },
        { raw: 'street address', title: 'Address 1', value: 'address1' },
        { raw: 'address 2', title: 'Address 2', value: 'address2' },
        { raw: 'city', title: 'City', value: 'city' },
        { raw: 'state', title: 'Province', value: 'province' },
        { raw: 'zip', title: 'Zip', value: 'zip' },
        { raw: 'country', title: 'Country', value: 'country' },
        { raw: 'product name', title: 'Product', value: 'product', isCustom: true }
      ]
    },
    after: {
      action: 'message',
      messageHeading: 'Inquiry received',
      messageBody: "Thank you for your inquiry! We'll follow up shortly to confirm the details.",
      redirectUrl: ''
    }
  };

  const STEPS = ['select', 'note', 'recipients', 'touches', 'tie'];
  const CAPTIONS = {
    select: 'Your gift, taking shape',
    note: 'Your note, ready to send',
    recipients: 'Ready for every doorstep',
    touches: 'The finishing touches',
    tie: 'Tied with a bow'
  };
  const SPECIAL_ROLES = ['import', 'date', 'occasion', 'message', 'items'];
  const ADDRESS_REQUIRED = ['fullName', 'address1', 'city', 'province', 'zip', 'country'];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  const norm = (value) => String(value == null ? '' : value).toLowerCase().trim();
  const splitList = (value) => String(value || '').split(',').map(norm).filter(Boolean);
  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const hash = (str) => [...String(str)].reduce((h, c) => ((h << 5) - h + c.charCodeAt(0)) | 0, 7);
  const todayYmd = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };
  const safe = (fn, fallback = null) => {
    try {
      return fn();
    } catch (e) {
      return fallback;
    }
  };
  const local = {
    get: (k) => safe(() => JSON.parse(window.localStorage.getItem(k))),
    set: (k, v) => safe(() => window.localStorage.setItem(k, JSON.stringify(v))),
    del: (k) => safe(() => window.localStorage.removeItem(k))
  };
  const sess = {
    get: (k) => safe(() => JSON.parse(window.sessionStorage.getItem(k))),
    set: (k, v) => safe(() => window.sessionStorage.setItem(k, JSON.stringify(v)))
  };

  function readS2M() {
    const s = window.s2mImportAppSettings;
    const mo = s && s.metaobject;
    const fields = mo && mo.settings && Array.isArray(mo.settings.formFields) && mo.settings.formFields.length ? mo.settings.formFields : FALLBACK_S2M.formFields;
    return {
      live: fields !== FALLBACK_S2M.formFields,
      proxy: (s && s.proxySubpath) || 'send-to-many',
      instance: (s && s.settingsInstanceId) || '1',
      fields,
      importFormat: (mo && mo.import_format) || FALLBACK_S2M.importFormat,
      after: (mo && mo.settings && mo.settings.afterSubmissionActionData) || FALLBACK_S2M.after,
      pageData: (s && s.pageData) || null,
      customer: (s && s.customer) || null
    };
  }

  function assignRoles(fields) {
    const taken = new Set();
    return fields.map((f) => {
      const label = norm(f.label);
      let role = 'contact';
      if (f.type === 'import') role = 'import';
      else if (f.type === 'date' && !taken.has('date')) role = 'date';
      else if ((f.type === 'dropdown' || f.type === 'radioButtons') && /occasion/.test(label) && !taken.has('occasion')) role = 'occasion';
      else if ((f.type === 'textarea' || f.type === 'text') && (f.id === 's2m-message' || /gift message|handwritten|note/.test(label)) && !taken.has('message')) role = 'message';
      else if ((f.type === 'text' || f.type === 'textarea') && /item|product|interest/.test(label) && !taken.has('items')) role = 'items';
      if (role !== 'contact' && role !== 'import') taken.add(role);
      return { field: f, role };
    });
  }

  function parseCsv(text) {
    const rows = [];
    let row = [];
    let cell = '';
    let quoted = false;
    for (let i = 0; i < text.length; i++) {
      const c = text[i];
      if (quoted) {
        if (c === '"' && text[i + 1] === '"') {
          cell += '"';
          i++;
        } else if (c === '"') quoted = false;
        else cell += c;
      } else if (c === '"') quoted = true;
      else if (c === ',') {
        row.push(cell);
        cell = '';
      } else if (c === '\n' || c === '\r') {
        if (c === '\r' && text[i + 1] === '\n') i++;
        row.push(cell);
        rows.push(row);
        row = [];
        cell = '';
      } else cell += c;
    }
    if (cell !== '' || row.length) {
      row.push(cell);
      rows.push(row);
    }
    return rows.map((r) => r.map((v) => v.trim())).filter((r) => r.some((v) => v !== ''));
  }

  const csvCell = (v) => {
    const s = String(v == null ? '' : v);
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  class CgConcierge extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const cfgEl = this.querySelector('[data-cgc-config]');
      this.cfg = safe(() => JSON.parse(cfgEl.textContent), {}) || {};
      this.sid = this.cfg.sectionId || this.dataset.sectionId || 'cgc';
      this.storeKey = `cgc:v3:${this.sid}`;
      this.s2m = readS2M();
      this.roles = assignRoles(this.s2m.fields);
      this.tiers = String(this.cfg.discountTiers || '')
        .split(',')
        .map((part) => part.split('='))
        .map(([min, pct]) => ({ min: Math.round(parseFloat(String(min).replace(/[^\d.]/g, '')) * 100), pct: parseFloat(pct) }))
        .filter((t) => t.min > 0 && t.pct > 0)
        .sort((a, b) => a.min - b.min);
      this.money = new Intl.NumberFormat(this.cfg.locale || 'en', { style: 'currency', currency: this.cfg.currency || 'USD' });
      this.products = new Map();
      this.values = {};
      this.address = {};
      this.file = null;
      this.fileInfo = null;
      this.submitted = false;
      this.state = this.freshState();
      this.listeners = [];

      this.captureUtm();
      this.buildLiveRegion();
      this.setupCatalog();
      this.setupNote();
      this.setupRecipients();
      this.setupTouches();
      this.setupDetails();
      this.setupStage();
      this.setupClassic();
      this.restore();
      this.setupScroll();
      this.update();
      this.classList.add('cgc--ready');
    }

    disconnectedCallback() {
      this.listeners.forEach(([target, type, fn]) => target.removeEventListener(type, fn));
      this.listeners = [];
      (this.observers || []).forEach((o) => o.disconnect());
    }

    on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      this.listeners.push([target, type, fn]);
    }

    $(sel) {
      return this.querySelector(sel);
    }

    $$(sel) {
      return [...this.querySelectorAll(sel)];
    }

    freshState() {
      return {
        items: {},
        order: [],
        occasion: null,
        noteOn: true,
        message: '',
        signoff: '',
        mode: null,
        count: null,
        date: '',
        addons: {}
      };
    }

    fieldFor(role) {
      const hit = this.roles.find((r) => r.role === role);
      return hit ? hit.field : null;
    }

    fmt(cents) {
      return this.money.format((Number(cents) || 0) / 100);
    }

    announce(msg) {
      if (!this.live) return;
      this.live.textContent = '';
      window.requestAnimationFrame(() => {
        this.live.textContent = msg;
      });
    }

    track(name, data = {}) {
      const id = safe(() => window.crypto.randomUUID()) || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      const payload = { event_id: `${name}-${id}`, page_path: window.location.pathname, ...data };
      safe(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...payload });
      });
      safe(() => window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish(name, payload));
    }

    captureUtm() {
      const params = new URLSearchParams(window.location.search);
      const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
      const found = {};
      keys.forEach((k) => {
        if (params.get(k)) found[k] = params.get(k).slice(0, 120);
      });
      if (Object.keys(found).length) sess.set('cgc:utm', found);
      this.utm = sess.get('cgc:utm') || null;
    }

    buildLiveRegion() {
      this.live = document.createElement('p');
      this.live.className = 'cgc-sr';
      this.live.setAttribute('aria-live', 'polite');
      this.appendChild(this.live);
    }

    setupCatalog() {
      this.grid = this.$('[data-cgc-grid]');
      this.chipsEl = this.$('[data-cgc-chips]');
      if (this.chipsEl) this.chipsEl.setAttribute('role', 'group');
      const cats = (this.cfg.categories || []).map((c) => ({
        ...c,
        types: splitList(c.types),
        tags: splitList(c.tags),
        keywords: splitList(c.keywords),
        includesBag: !!c.includesBag,
        count: 0,
        interest: false
      }));
      this.bagCats = new Set(cats.filter((c) => c.includesBag).map((c) => c.id));
      const other = { id: 'other', title: this.cfg.otherLabel || 'More gifts', count: 0 };
      const cards = this.$$('[data-cgc-card]');
      cards.forEach((card, index) => {
        const type = norm(card.dataset.type);
        const tags = (card.dataset.tags || '').split('|').map(norm);
        const title = norm(card.dataset.title);
        const cat = cats.find((c) => (type && c.types.includes(type)) || c.tags.some((t) => tags.includes(t)) || c.keywords.some((k) => title.includes(k))) || other;
        cat.count += 1;
        card.dataset.cat = cat.id;
        card.dataset.index = index;
        const select = card.querySelector('[data-cgc-variant]');
        this.products.set(card.dataset.id, {
          id: card.dataset.id,
          title: card.dataset.title,
          price: Number(card.dataset.price) || 0,
          variantId: card.dataset.variant,
          variantTitle: select ? select.options[select.selectedIndex].text : '',
          image: card.dataset.image || '',
          available: card.dataset.available === 'true',
          cat: cat.id,
          card
        });
      });

      cats.filter((c) => !c.count && c.emptyMessage).forEach((c) => {
        c.interest = true;
        c.count = 1;
        const id = `interest-${c.id}`;
        const card = document.createElement('article');
        card.className = 'cgc-card cgc-card--interest';
        card.dataset.cgcCard = '';
        card.dataset.id = id;
        card.dataset.cat = c.id;
        card.innerHTML = `
          <div class="cgc-card__media"><p class="cgc-interest__mark">Coming soon<b>${esc(c.title)}</b></p></div>
          <div class="cgc-card__body">
            <h3 class="cgc-card__title">${esc(c.title)}</h3>
            <p class="cgc-card__text">${esc(c.emptyMessage)}</p>
            <div class="cgc-card__actions"><button type="button" class="cgc-card__add" data-cgc-add aria-pressed="false">Request ${esc(c.title)}</button></div>
          </div>`;
        if (this.grid) this.grid.appendChild(card);
        this.products.set(id, { id, title: c.title, price: 0, variantId: null, variantTitle: '', image: '', available: true, cat: c.id, interest: true, card });
      });

      const visibleCats = cats.filter((c) => c.count > 0);
      if (other.count) visibleCats.push(other);
      this.cats = visibleCats;
      this.catTitles = Object.fromEntries(visibleCats.map((c) => [c.id, c.title]));

      if (this.grid) {
        const rank = Object.fromEntries(visibleCats.map((c, i) => [c.id, i]));
        [...this.grid.children]
          .sort((a, b) => (rank[a.dataset.cat] ?? 99) - (rank[b.dataset.cat] ?? 99) || (Number(a.dataset.index) || 0) - (Number(b.dataset.index) || 0))
          .forEach((el) => this.grid.appendChild(el));
        this.on(this.grid, 'click', (e) => this.onGridClick(e));
        this.on(this.grid, 'change', (e) => this.onVariantChange(e));
        this.on(this.grid, 'input', (e) => {
          const field = e.target.closest('[data-cgc-count]');
          if (!field) return;
          const digits = field.value.replace(/[^\d]/g, '');
          if (digits !== field.value) field.value = digits;
          const n = parseInt(digits, 10);
          if (n > 0) this.setQty(field.closest('[data-cgc-card]').dataset.id, n);
        });
        this.on(this.grid, 'focusout', (e) => {
          const field = e.target.closest('[data-cgc-count]');
          if (!field) return;
          const id = field.closest('[data-cgc-card]').dataset.id;
          const n = parseInt(field.value, 10);
          if (!n) this.setQty(id, 0);
          else field.value = String(this.state.items[id] ? this.state.items[id].qty : 0);
        });
      }

      if (this.chipsEl) {
        const chips = visibleCats.map((c) => ({ id: c.id, title: c.title, badge: c.interest ? 'Soon' : String(c.count) }));
        if (visibleCats.length > 1) chips.unshift({ id: 'all', title: this.cfg.allLabel || 'All gifts', badge: String(this.products.size) });
        this.chipsEl.innerHTML = chips
          .map((c) => `<button type="button" class="cgc-pill" data-cgc-chip="${esc(c.id)}" aria-pressed="false">${esc(c.title)}<span class="cgc-pill__count">${esc(c.badge)}</span></button>`)
          .join('');
        this.on(this.chipsEl, 'click', (e) => {
          const chip = e.target.closest('[data-cgc-chip]');
          if (chip) this.setCategory(chip.dataset.cgcChip, true);
        });
      }
      this.setCategory(visibleCats.length === 1 ? visibleCats[0].id : 'all', false);
    }

    setCategory(id, animate) {
      this.activeCat = id;
      if (this.chipsEl) {
        this.$$('[data-cgc-chip]').forEach((chip) => {
          const active = chip.dataset.cgcChip === id;
          chip.setAttribute('aria-pressed', String(active));
          if (active && animate) chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      }
      let n = 0;
      this.products.forEach((p) => {
        const show = id === 'all' || p.cat === id;
        p.card.hidden = !show;
        if (show && animate) {
          p.card.style.setProperty('--n', String(Math.min(n++, 16)));
          p.card.style.animation = 'none';
          void p.card.offsetWidth;
          p.card.style.animation = '';
        }
      });
      if (animate) this.track('cg_concierge_category', { category: this.catTitles[id] || id });
    }

    onGridClick(e) {
      const card = e.target.closest('[data-cgc-card]');
      if (!card) return;
      const id = card.dataset.id;
      if (e.target.closest('[data-cgc-add]')) {
        const p = this.products.get(id);
        if (p && p.interest && this.state.items[id]) this.setQty(id, 0);
        else this.changeQty(id, 1);
      } else if (e.target.closest('[data-cgc-inc]')) this.changeQty(id, 1);
      else if (e.target.closest('[data-cgc-dec]')) this.changeQty(id, -1);
    }

    onVariantChange(e) {
      const select = e.target.closest('[data-cgc-variant]');
      if (!select) return;
      const card = select.closest('[data-cgc-card]');
      const p = this.products.get(card.dataset.id);
      const opt = select.options[select.selectedIndex];
      p.variantId = opt.value;
      p.variantTitle = opt.text;
      p.price = Number(opt.dataset.price) || p.price;
      const priceEl = card.querySelector('[data-cgc-price]');
      if (priceEl) priceEl.textContent = this.fmt(p.price);
      const item = this.state.items[p.id];
      if (item) Object.assign(item, { variantId: p.variantId, variantTitle: p.variantTitle, price: p.price });
      this.update();
    }

    changeQty(id, delta) {
      const current = this.state.items[id] ? this.state.items[id].qty : 0;
      this.setQty(id, current + delta);
    }

    setQty(id, qty) {
      const p = this.products.get(id);
      if (!p) return;
      const next = p.interest ? clamp(qty, 0, 1) : clamp(qty, 0, 99);
      const had = !!this.state.items[id];
      if (next === 0) {
        delete this.state.items[id];
        this.state.order = this.state.order.filter((x) => x !== id);
        this.announce(`Removed ${p.title} from your gift.`);
      } else {
        this.state.items[id] = {
          id,
          qty: next,
          title: p.title,
          price: p.price,
          variantId: p.variantId,
          variantTitle: p.variantTitle,
          image: p.image,
          available: p.available,
          interest: !!p.interest,
          cat: p.cat
        };
        if (!had) {
          this.state.order.push(id);
          this.announce(p.interest ? `Requested ${p.title}.` : `Added ${p.title} to your gift.`);
          this.track('cg_concierge_add', { product_id: id, title: p.title, price: p.price / 100, interest: !!p.interest });
          if (!this.startTracked && !sess.get('cgc:started')) {
            this.startTracked = true;
            sess.set('cgc:started', true);
            this.track('cg_concierge_started', { product_id: id, title: p.title, currency: this.cfg.currency || 'USD' });
          }
        } else this.announce(`${p.title}: ${next}.`);
      }
      this.bump = id;
      this.update();
    }

    syncCards() {
      this.products.forEach((p) => {
        const item = this.state.items[p.id];
        const card = p.card;
        card.classList.toggle('is-selected', !!item);
        const add = card.querySelector('[data-cgc-add]');
        const qty = card.querySelector('[data-cgc-qty]');
        if (p.interest) {
          if (add) {
            add.setAttribute('aria-pressed', String(!!item));
            add.textContent = item ? 'Requested' : `Request ${p.title}`;
          }
          return;
        }
        if (add) add.hidden = !!item;
        if (qty) {
          qty.hidden = !item;
          const out = qty.querySelector('[data-cgc-count]');
          if (out && out !== document.activeElement) out.value = item ? String(item.qty) : '0';
        }
      });
    }

    setupNote() {
      this.occasionField = this.fieldFor('occasion');
      const s2mOptions = this.occasionField && Array.isArray(this.occasionField.options) ? this.occasionField.options : [];
      const known = new Set(s2mOptions.map((o) => norm(o.label)));
      const fallback = s2mOptions.find((o) => norm(o.label) === 'other') || null;
      const extras = String(this.cfg.extraOccasions || '')
        .split(',')
        .map((l) => l.trim())
        .filter((l) => l && !known.has(norm(l)))
        .map((l) => ({ id: `cgc-occasion-${norm(l).replace(/[^a-z0-9]+/g, '-')}`, label: l, extra: true, mapsTo: fallback ? fallback.id : null }));
      this.occasionOptions = [...extras, ...s2mOptions];
      const wrap = this.$('[data-cgc-occasion-wrap]');
      const holder = this.$('[data-cgc-occasion]');
      if (this.occasionField && wrap && holder && this.occasionOptions.length) {
        wrap.hidden = false;
        holder.innerHTML = this.occasionOptions
          .map((o) => `<label class="cgc-pill"><input type="radio" class="cgc-sr" name="cgc-occasion-${esc(this.sid)}" value="${esc(o.id)}" data-cgc-occasion-opt>${esc(o.label)}</label>`)
          .join('');
        this.on(holder, 'change', (e) => {
          if (e.target.matches('[data-cgc-occasion-opt]')) {
            this.state.occasion = e.target.value;
            this.update();
          }
        });
      }
      this.messageEl = this.$('[data-cgc-message]');
      this.signoffEl = this.$('[data-cgc-signoff]');
      this.noteOnEl = this.$('[data-cgc-note-on]');
      this.noteFields = this.$('[data-cgc-note-fields]');
      this.countEl = this.$('[data-cgc-message-count]');
      if (this.messageEl) {
        this.on(this.messageEl, 'input', () => {
          this.state.message = this.messageEl.value;
          this.messageEl.removeAttribute('aria-invalid');
          this.update();
        });
      }
      if (this.signoffEl) {
        this.on(this.signoffEl, 'input', () => {
          this.state.signoff = this.signoffEl.value;
          this.update();
        });
      }
      if (this.noteOnEl) {
        this.on(this.noteOnEl, 'change', () => {
          this.state.noteOn = this.noteOnEl.checked;
          this.update();
        });
      }
      this.$$('[data-cgc-prompt]').forEach((btn) => {
        this.on(btn, 'click', () => {
          if (!this.messageEl) return;
          this.messageEl.value = btn.dataset.cgcPrompt;
          this.state.message = this.messageEl.value;
          this.state.noteOn = true;
          if (this.noteOnEl) this.noteOnEl.checked = true;
          this.messageEl.focus();
          this.update();
        });
      });
    }

    setupRecipients() {
      this.$$('[data-cgc-addr]').forEach((input) => {
        this.on(input, 'input', () => {
          this.address[input.dataset.cgcAddr] = input.value.trim();
          input.removeAttribute('aria-invalid');
          this.update();
        });
        this.address[input.dataset.cgcAddr] = input.value.trim();
      });
      this.countInput = this.$('[data-cgc-count-input]');
      if (this.countInput) {
        this.on(this.countInput, 'input', () => {
          const digits = this.countInput.value.replace(/[^\d]/g, '');
          const n = digits ? parseInt(digits, 10) : 0;
          this.setCount(n > 0 ? Math.min(n, 100000) : null);
          this.countInput.removeAttribute('aria-invalid');
        });
        this.on(this.countInput, 'blur', () => {
          this.countInput.value = this.state.count ? String(this.state.count) : '';
        });
      }

      this.dateField = this.fieldFor('date');
      this.dateEl = this.$('[data-cgc-date]');
      const dateWrap = this.$('[data-cgc-date-wrap]');
      if (!this.dateField && dateWrap) dateWrap.hidden = true;
      if (this.dateEl) {
        this.dateEl.min = todayYmd();
        this.on(this.dateEl, 'change', () => {
          this.state.date = this.dateEl.value;
          this.dateEl.removeAttribute('aria-invalid');
          this.update();
        });
      }

      this.importField = this.fieldFor('import');
      const upload = this.$('[data-cgc-upload]');
      if (!this.importField && upload) upload.hidden = true;
      this.fileInput = this.$('[data-cgc-file]');
      this.drop = this.$('[data-cgc-drop]');
      this.fileResult = this.$('[data-cgc-file-result]');
      if (this.fileInput) {
        this.on(this.fileInput, 'change', () => {
          if (this.fileInput.files && this.fileInput.files[0]) this.handleFile(this.fileInput.files[0]);
        });
      }
      if (this.drop) {
        ['dragenter', 'dragover'].forEach((type) =>
          this.on(this.drop, type, (e) => {
            e.preventDefault();
            this.drop.classList.add('is-over');
          })
        );
        ['dragleave', 'drop'].forEach((type) =>
          this.on(this.drop, type, (e) => {
            e.preventDefault();
            this.drop.classList.remove('is-over');
            if (type === 'drop' && e.dataTransfer && e.dataTransfer.files[0]) this.handleFile(e.dataTransfer.files[0]);
          })
        );
      }
      if (this.fileResult) {
        this.on(this.fileResult, 'click', (e) => {
          if (e.target.closest('[data-cgc-file-remove]')) this.clearFile();
        });
      }
      this.setupTemplateLink();
    }

    setCount(n) {
      const prevMode = this.state.mode;
      this.state.count = n;
      this.state.mode = !n ? null : n === 1 ? 'one' : 'many';
      if (this.state.mode && this.state.mode !== prevMode) this.track('cg_concierge_recipients', { mode: this.state.mode, count: n });
      this.update();
    }

    setupTemplateLink() {
      const link = this.$('[data-cgc-template]');
      if (!link) return;
      const headers = (this.s2m.importFormat.headers || []).filter((h) => !h.exclude);
      const csv = `${headers.map((h) => csvCell(h.raw)).join(',')}\r\n`;
      safe(() => {
        link.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
      });
      if (!this.importField) return;
      fetch(`/apps/${this.s2m.proxy}/proxy/init?instance=${encodeURIComponent(this.s2m.instance)}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (data && data.importFileUrl) {
            link.href = data.importFileUrl;
            link.target = '_blank';
            link.rel = 'noopener';
            if (data.importFileName) link.setAttribute('download', data.importFileName);
          }
        })
        .catch(() => {});
    }

    async handleFile(file) {
      if (file.size > 15 * 1024 * 1024) {
        this.showFileResult(`<p class="cgc-upload__meta cgc-upload__meta--warn">That file is larger than 15 MB. Please send a smaller list.</p>`);
        return;
      }
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      this.file = file;
      this.fileInfo = { name: file.name, rows: 0, error: null, preview: null };
      if (ext === 'csv' || file.type === 'text/csv') {
        const text = await file.text();
        const rows = parseCsv(text.replace(/^﻿/, ''));
        const formatHeaders = (this.s2m.importFormat.headers || []).filter((h) => !h.exclude).map((h) => norm(h.raw));
        const fileHeaders = (rows[0] || []).map(norm);
        const valid = formatHeaders.every((h) => fileHeaders.includes(h)) && fileHeaders.every((h) => formatHeaders.includes(h));
        if (!rows.length || rows.length < 2) this.fileInfo.error = 'No rows found in the uploaded file';
        else if (!valid) this.fileInfo.error = 'Invalid headers found in the uploaded file';
        this.fileInfo.rows = this.fileInfo.error ? 0 : rows.length - 1;
        this.fileInfo.preview = rows.slice(0, 4);
      }
      if (this.fileInfo.rows > 1 && this.fileInfo.rows !== this.state.count) {
        this.fileInfo.countUpdated = true;
        if (this.countInput) this.countInput.value = String(this.fileInfo.rows);
        this.state.count = this.fileInfo.rows;
        this.state.mode = 'many';
      }
      this.renderFileResult();
      this.track('cg_concierge_list_added', { rows: this.fileInfo.rows });
      this.update();
    }

    clearFile() {
      this.file = null;
      this.fileInfo = null;
      if (this.fileInput) this.fileInput.value = '';
      if (this.fileResult) {
        this.fileResult.hidden = true;
        this.fileResult.innerHTML = '';
      }
      const text = this.$('[data-cgc-drop-text]');
      if (text) text.textContent = 'Drop your completed list here, or click to browse';
      this.update();
    }

    showFileResult(html) {
      if (!this.fileResult) return;
      this.fileResult.hidden = false;
      this.fileResult.innerHTML = html;
    }

    renderFileResult() {
      const info = this.fileInfo;
      if (!info) return;
      const text = this.$('[data-cgc-drop-text]');
      if (text) text.textContent = 'Replace your list';
      let meta = '';
      if (info.error) meta = `<p class="cgc-upload__meta cgc-upload__meta--warn">${esc(info.error)}. We'll still send it, but the columns should match our template so we can process it quickly.</p>`;
      else if (info.rows) meta = `<p class="cgc-upload__meta">${info.rows} recipient${info.rows === 1 ? '' : 's'} found${info.countUpdated ? '. We updated your recipient count to match.' : '.'}</p>`;
      else meta = `<p class="cgc-upload__meta">Spreadsheet attached. We'll review every row.</p>`;
      let table = '';
      if (info.preview && info.preview.length > 1 && !info.error) {
        const [head, ...body] = info.preview;
        table = `<div class="cgc-upload__scroll"><table class="cgc-upload__table"><thead><tr>${head.map((h) => `<th>${esc(h)}</th>`).join('')}</tr></thead><tbody>${body
          .map((r) => `<tr>${r.map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`)
          .join('')}</tbody></table></div>`;
      }
      this.showFileResult(`<div class="cgc-upload__row"><span class="cgc-upload__name">${esc(info.name)}</span><button type="button" class="cgc-link" data-cgc-file-remove>Remove</button></div>${meta}${table}`);
    }

    setupTouches() {
      this.addons = Object.fromEntries((this.cfg.addons || []).map((a) => [a.id, a]));
      this.$$('[data-cgc-addon]').forEach((input) => {
        this.on(input, 'change', () => {
          const id = input.dataset.cgcAddon;
          if (input.checked) this.state.addons[id] = true;
          else delete this.state.addons[id];
          const addon = this.addons[id];
          if (addon && input.checked) this.track('cg_concierge_touch', { touch: addon.title });
          this.update();
        });
      });
    }

    renderTouches(t) {
      this.$$('[data-cgc-addon]').forEach((input) => {
        const id = input.dataset.cgcAddon;
        const addon = this.addons[id];
        const included = !!(addon && addon.kind === 'bag' && t.bagIncluded);
        if (included) {
          input.checked = false;
          delete this.state.addons[id];
        }
        input.disabled = included;
        const card = input.closest('.cgc-addon');
        if (card) card.classList.toggle('is-included', included);
        const note = card && card.querySelector('[data-cgc-addon-included]');
        if (note) note.hidden = !included;
      });
    }

    hasAddonKind(kind) {
      return Object.keys(this.state.addons).some((id) => this.addons[id] && this.addons[id].kind === kind);
    }

    setupDetails() {
      this.contactEl = this.$('[data-cgc-contact]');
      this.form = this.$('[data-cgc-form]');
      this.errorsEl = this.$('[data-cgc-errors]');
      this.renderContact();
      if (this.contactEl) {
        this.on(this.contactEl, 'input', (e) => this.onFieldInput(e));
        this.on(this.contactEl, 'change', (e) => this.onFieldInput(e));
      }
      if (this.form) this.on(this.form, 'submit', (e) => this.submit(e));
      const restart = this.$('[data-cgc-restart]');
      if (restart) this.on(restart, 'click', () => this.restart());
      if (this.errorsEl) {
        this.on(this.errorsEl, 'click', (e) => {
          const a = e.target.closest('[data-cgc-goto]');
          if (!a) return;
          e.preventDefault();
          const target = document.getElementById(a.dataset.cgcGoto);
          if (target) {
            target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
            window.setTimeout(() => target.focus && target.focus({ preventScroll: true }), 450);
          }
        });
      }
    }

    renderContact() {
      this.unsupported = [];
      const customer = this.s2m.customer || this.cfg.customer || null;
      const supported = ['customerFirstName', 'customerLastName', 'text', 'email', 'phone', 'number', 'date', 'textarea', 'dropdown', 'checkbox', 'radioButtons', 'multipleChoice'];
      const html = this.roles
        .filter((r) => !SPECIAL_ROLES.includes(r.role))
        .map(({ field: f }) => {
          if (!supported.includes(f.type)) {
            this.unsupported.push(f);
            return '';
          }
          let preset = null;
          if (customer) {
            if (f.type === 'customerFirstName') preset = customer.first_name;
            else if (f.type === 'customerLastName') preset = customer.last_name;
            else if (f.type === 'email') preset = customer.email;
            else if (f.type === 'phone') preset = customer.phone;
            else if (f.type === 'text' && /company/.test(norm(f.label))) preset = customer.current_company_name;
          }
          if (preset) this.values[f.id] = preset;
          if (f.type === 'checkbox') this.values[f.id] = false;
          if (f.type === 'multipleChoice') this.values[f.id] = [];
          return this.fieldHtml(f, preset);
        })
        .join('');
      if (this.contactEl) this.contactEl.innerHTML = html;
    }

    fieldHtml(f, preset) {
      const id = `cgc-f-${this.sid}-${f.id}`;
      const star = f.required ? ' <span aria-hidden="true">*</span>' : '';
      const req = f.required ? ' required aria-required="true"' : '';
      const full = f.width === '100%' || ['textarea', 'checkbox', 'radioButtons', 'multipleChoice'].includes(f.type);
      const cls = `cgc-field${full ? ' cgc-field--full' : ''}`;
      const auto = f.inputAutocomplete ? ` autocomplete="${esc(f.inputAutocomplete)}"` : '';
      const ph = f.placeholder ? ` placeholder="${esc(f.placeholder)}"` : '';
      const val = preset ? ` value="${esc(preset)}"` : '';
      const data = ` data-cgc-field="${esc(f.id)}"`;
      const label = `<label class="cgc-label" for="${id}">${esc(f.label)}${star}</label>`;
      const inputType = { customerFirstName: 'text', customerLastName: 'text', text: 'text', email: 'email', phone: 'tel', number: 'number', date: 'date' }[f.type];
      if (inputType) return `<div class="${cls}">${label}<input class="cgc-input" id="${id}" type="${inputType}"${auto}${ph}${val}${req}${data}></div>`;
      if (f.type === 'textarea') return `<div class="${cls}">${label}<textarea class="cgc-input" id="${id}" rows="4"${ph}${req}${data}>${esc(preset || '')}</textarea></div>`;
      if (f.type === 'dropdown') {
        const opts = (f.options || []).map((o) => `<option value="${esc(o.id)}">${esc(o.label)}</option>`).join('');
        return `<div class="${cls}">${label}<select class="cgc-input" id="${id}"${req}${data}><option value="">Select</option>${opts}</select></div>`;
      }
      if (f.type === 'checkbox') return `<div class="${cls}"><label class="cgc-check"><input type="checkbox" id="${id}"${req}${data}><span>${esc(f.label)}${star}</span></label></div>`;
      const multi = f.type === 'multipleChoice';
      const opts = (f.options || [])
        .map((o) => `<label class="cgc-pill"><input class="cgc-sr" type="${multi ? 'checkbox' : 'radio'}" name="${id}" value="${esc(o.id)}"${data}>${esc(o.label)}</label>`)
        .join('');
      return `<fieldset class="${cls} cgc-fieldset" id="${id}" tabindex="-1"><legend class="cgc-label">${esc(f.label)}${star}</legend><div class="cgc-pills">${opts}</div></fieldset>`;
    }

    onFieldInput(e) {
      const el = e.target.closest('[data-cgc-field]');
      if (!el) return;
      const id = el.dataset.cgcField;
      const f = this.s2m.fields.find((x) => x.id === id);
      if (!f) return;
      if (f.type === 'checkbox') this.values[id] = el.checked;
      else if (f.type === 'multipleChoice') this.values[id] = this.$$(`[data-cgc-field="${CSS.escape(id)}"]:checked`).map((x) => x.value);
      else this.values[id] = el.value;
      el.removeAttribute('aria-invalid');
      const err = el.closest('.cgc-field') && el.closest('.cgc-field').querySelector('.cgc-field__error');
      if (err) err.remove();
      this.update();
    }

    setupStage() {
      this.stage = this.$('[data-cgc-stage]');
      this.scene = this.$('[data-cgc-scene]');
      this.tiles = this.$('[data-cgc-tiles]');
      this.dock = this.$('[data-cgc-dock]');
      // Shopify's staff preview bar covers the bottom of the window; keep the summary above it.
      const syncBar = () => {
        const bar = document.querySelector('#PBarNextFrameWrapper, #PBarNextFrame, #preview-bar-iframe');
        const r = bar ? bar.getBoundingClientRect() : null;
        const h = r && r.height && r.bottom >= window.innerHeight - 2 ? clamp(window.innerHeight - r.top, 0, 160) : 0;
        this.style.setProperty('--cgc-bar', `${Math.round(h)}px`);
      };
      [0, 1500, 4000, 8000].forEach((ms) => window.setTimeout(syncBar, ms));
      this.on(window, 'resize', syncBar);
      if (this.dock) {
        this.on(this.dock, 'click', () => this.toggleSheet());
        this.on(document, 'keydown', (e) => {
          if (e.key === 'Escape' && this.stage.classList.contains('is-open')) this.toggleSheet(false);
        });
      }
    }

    toggleSheet(force) {
      const open = typeof force === 'boolean' ? force : !this.stage.classList.contains('is-open');
      this.stage.classList.toggle('is-open', open);
      this.dock.setAttribute('aria-expanded', String(open));
      const cta = this.$('[data-cgc-dock-cta]');
      if (cta) cta.textContent = open ? 'Close' : 'View';
    }

    setupClassic() {
      const block = document.querySelector('[id*="send_to_many_import_form"], [id^="s2m-import-app"]');
      this.classicSection = block ? block.closest('.shopify-section') : null;
      const wrap = this.$('[data-cgc-classic-wrap]');
      const toggle = this.$('[data-cgc-classic]');
      if (!this.classicSection || this.classicSection.contains(this)) {
        if (wrap) wrap.hidden = true;
        return;
      }
      if (this.cfg.classic === 'show') {
        if (wrap) wrap.hidden = true;
        return;
      }
      this.classicSection.classList.add('cgc-classic-hidden');
      if (toggle) {
        this.on(toggle, 'click', () => this.toggleClassic());
      }
    }

    toggleClassic(force) {
      if (!this.classicSection) return;
      const toggle = this.$('[data-cgc-classic]');
      const open = typeof force === 'boolean' ? force : this.classicSection.classList.contains('cgc-classic-hidden');
      this.classicSection.classList.toggle('cgc-classic-hidden', !open);
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      if (open) this.classicSection.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    }

    setupScroll() {
      this.on(this, 'click', (e) => {
        if (e.target.closest('[data-cgc-mailto]')) this.track('cg_concierge_email_click', { location: 'hero' });
        const link = e.target.closest('a[href^="#"]');
        if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
        const id = link.getAttribute('href').slice(1);
        const target = id ? document.getElementById(id) : null;
        if (!target || !this.contains(target)) return;
        e.preventDefault();
        this.scrollToSection(target);
      });
      this.observers = [];

      const reveal = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              reveal.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      this.$$('[data-cgc-reveal]').forEach((el) => reveal.observe(el));
      this.observers.push(reveal);

      const builder = this.$('[data-cgc-builder]');
      if (builder) {
        const io = new IntersectionObserver((entries) => entries.forEach((e) => this.classList.toggle('cgc--in-builder', e.isIntersecting)), { rootMargin: '-45% 0px -45% 0px' });
        io.observe(builder);
        this.observers.push(io);
      }

      const stepIo = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) this.setStep(e.target.dataset.cgcStep);
          });
        },
        { rootMargin: '-40% 0px -55% 0px' }
      );
      this.$$('[data-cgc-step]').forEach((s) => stepIo.observe(s));
      this.observers.push(stepIo);

      if (!this.cfg.parallax || reduceMotion.matches) return;
      this.px = this.$$('[data-cgc-parallax]').map((el) => ({ el, speed: parseFloat(el.dataset.cgcParallax) || 0, host: el.parentElement }));
      this.hero = this.$('.cgc-hero');
      this.heroContent = this.$('[data-cgc-hero-content]');
      const tick = () => {
        this.raf = null;
        const vh = window.innerHeight;
        this.px.forEach((p) => {
          const r = p.host.getBoundingClientRect();
          if (r.bottom < -300 || r.top > vh + 300) return;
          const delta = r.top + r.height / 2 - vh / 2;
          p.el.style.transform = `translate3d(0, ${(-delta * p.speed).toFixed(1)}px, 0)`;
        });
        if (this.hero && this.heroContent) {
          const hr = this.hero.getBoundingClientRect();
          const t = clamp(-hr.top / Math.max(hr.height, 1), 0, 1);
          this.heroContent.style.opacity = String(1 - t * 1.3);
          this.heroContent.style.transform = `translate3d(0, ${(t * 90).toFixed(1)}px, 0)`;
        }
      };
      const schedule = () => {
        if (!this.raf) this.raf = window.requestAnimationFrame(tick);
      };
      this.on(window, 'scroll', schedule, { passive: true });
      this.on(window, 'resize', schedule);
      tick();
    }

    scrollToSection(target) {
      const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
      window.scrollTo({ top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      const heading = target.querySelector('h1, h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        window.setTimeout(() => heading.focus({ preventScroll: true }), reduceMotion.matches ? 0 : 700);
      }
    }

    setStep(step) {
      if (!step || step === this.step) return;
      this.step = step;
      this.visited = this.visited || new Set();
      this.visited.add(step);
      this.track('cg_concierge_step', { step, step_number: STEPS.indexOf(step) + 1 });
      this.update();
    }

    totals() {
      const items = this.state.order.map((id) => this.state.items[id]).filter(Boolean);
      const goods = items.filter((i) => !i.interest);
      const recipients = this.state.count || 1;
      const giftUnits = goods.reduce((s, i) => s + i.qty, 0);
      const giftValue = goods.reduce((s, i) => s + i.price * i.qty, 0);
      const units = giftUnits * recipients;
      const productsTotal = giftValue * recipients;
      const bagIncluded = goods.some((i) => this.bagCats && this.bagCats.has(i.cat));
      const addonEach = items.length
        ? Object.keys(this.state.addons).reduce((s, id) => {
            const a = this.addons[id];
            return !a || (bagIncluded && a.kind === 'bag') ? s : s + (a.price || 0);
          }, 0)
        : 0;
      const addonsTotal = addonEach * recipients;
      const each = Number(this.cfg.shippingEach) || 0;
      const single = Number(this.cfg.shippingBulk) || 0;
      let shipping = 0;
      let shippingLabel = '';
      if (items.length && this.state.mode === 'one') {
        shipping = single;
        shippingLabel = 'One address, flat rate';
      } else if (items.length && this.state.mode === 'many') {
        shipping = each * recipients;
        shippingLabel = `${recipients.toLocaleString()} addresses \u00d7 ${this.fmt(each)}`;
      }
      const tier = [...this.tiers].reverse().find((tr) => productsTotal >= tr.min) || null;
      const nextTier = this.tiers.find((tr) => productsTotal < tr.min) || null;
      const discountPct = tier ? tier.pct : 0;
      const discount = Math.round((productsTotal * discountPct) / 100);
      const total = productsTotal + addonsTotal + shipping - discount;
      return { items, goods, giftUnits, giftValue, units, productsTotal, bagIncluded, addonEach, addonsTotal, recipients, shipping, shippingLabel, discountPct, discount, nextTier, total };
    }


    update() {
      const t = this.totals();
      this.syncCards();
      this.renderTiles(t);
      this.renderTouches(t);
      this.renderScene(t);
      this.renderTally(t);
      this.renderPanels();
      this.renderHints(t);
      this.renderRail(t);
      if (this.step === 'tie' || this.submitted) this.renderReview(t);
      this.save();
    }

    renderTiles(t) {
      if (!this.tiles) return;
      const max = 8;
      const list = t.items.length > max ? t.items.slice(0, max - 1) : t.items.slice();
      const extra = t.items.length - list.length;
      const entries = list.map((i) => ({ key: i.id, item: i }));
      if (extra > 0) entries.push({ key: 'more', more: extra });
      const n = entries.length;
      const front = n <= 2 ? n : Math.min(4, Math.ceil(n / 2));
      const back = n - front;
      const size = n <= 1 ? 50 : n <= 2 ? 44 : n <= 4 ? 38 : n <= 6 ? 33 : 30;
      const place = (count, i, spread) => 50 + (i - (count - 1) / 2) * spread;
      const spreadFor = (count) => (count <= 1 ? 0 : Math.min(30, 78 / (count - 1 || 1)));
      const existing = new Map([...this.tiles.children].map((li) => [li.dataset.key, li]));
      entries.forEach((entry, idx) => {
        const inBack = idx < back;
        const rowIndex = inBack ? idx : idx - back;
        const rowCount = inBack ? back : front;
        const x = place(rowCount, rowIndex, spreadFor(rowCount) * (inBack ? 0.9 : 1));
        const y = inBack ? 30 : n === 1 ? 12 : 8;
        const r = (Math.abs(hash(entry.key)) % 15) - 7;
        let li = existing.get(entry.key);
        const isNew = !li;
        if (isNew) {
          li = document.createElement('li');
          li.className = 'cgc-tile';
          li.dataset.key = entry.key;
          if (!reduceMotion.matches) li.classList.add('is-new');
          li.addEventListener('animationend', () => li.classList.remove('is-new', 'is-bump'));
        }
        existing.delete(entry.key);
        li.style.setProperty('--x', `${x}%`);
        li.style.setProperty('--y', `${y}%`);
        li.style.setProperty('--z', String((inBack ? 5 : 20) + rowCount - rowIndex));
        li.style.setProperty('--r', `${r}deg`);
        li.style.setProperty('--s', `${size}%`);
        if (entry.more) {
          li.classList.add('cgc-tile--more');
          li.innerHTML = `<span class="cgc-tile__card">+${entry.more}</span>`;
        } else {
          const it = entry.item;
          const card = it.interest
            ? `<span class="cgc-tile__card cgc-tile__card--interest">${esc(it.title)}</span>`
            : `<span class="cgc-tile__card">${it.image ? `<img src="${esc(it.image)}" alt="" loading="lazy">` : ''}</span>`;
          const qty = !it.interest && it.qty > 1 ? `<span class="cgc-tile__qty">×${it.qty}</span>` : '';
          const sig = `${it.image}|${it.qty}|${it.interest}`;
          if (li.dataset.sig !== sig) {
            li.innerHTML = card + qty;
            if (!isNew && this.bump === it.id) {
              li.classList.remove('is-bump');
              void li.offsetWidth;
              li.classList.add('is-bump');
            }
            li.dataset.sig = sig;
          }
        }
        if (isNew) this.tiles.appendChild(li);
      });
      existing.forEach((li) => {
        li.classList.add('is-leaving');
        window.setTimeout(() => li.remove(), reduceMotion.matches ? 0 : 420);
      });
      this.bump = null;
    }

    renderScene(t) {
      if (!this.scene) return;
      const s = this.state;
      const noteText = s.noteOn ? s.message.trim() : '';
      const tied = this.submitted || (this.step === 'tie' && t.items.length > 0);
      const ds = this.scene.dataset;
      ds.empty = String(!t.items.length);
      ds.mode = s.mode || '';
      ds.note = String(!!noteText);
      ds.handwritten = String(this.hasAddonKind('note'));
      ds.bag = String(this.hasAddonKind('bag') || t.bagIncluded);
      ds.tied = String(tied);
      const msg = this.$('[data-cgc-card-msg]');
      const sig = this.$('[data-cgc-card-sig]');
      if (msg) msg.textContent = noteText;
      if (sig) sig.textContent = s.signoff ? `— ${s.signoff}` : '';
      const count = this.$('[data-cgc-scene-count]');
      if (count) count.textContent = s.mode === 'many' ? `×${s.count.toLocaleString()}` : '';
      const tag = this.$('[data-cgc-tag-text]');
      if (tag) {
        const company = this.companyValue();
        tag.textContent = s.mode === 'one' && this.address.fullName ? `For ${this.address.fullName}` : company ? `From ${company}` : s.signoff ? s.signoff : 'With gratitude';
      }
      const caption = this.$('[data-cgc-stage-caption]');
      if (caption) caption.textContent = this.submitted ? 'Inquiry sent' : CAPTIONS[this.step] || CAPTIONS.select;
    }

    companyValue() {
      const f = this.s2m.fields.find((x) => /company/.test(norm(x.label)));
      return f ? String(this.values[f.id] || '').trim() : '';
    }

    renderTally(t) {
      const set = (sel, text) => {
        const el = this.$(sel);
        if (el) el.textContent = text;
      };
      const hasItems = t.items.length > 0;
      const itemsEl = this.$('[data-cgc-t-items]');
      const requests = t.items.length - t.goods.length;
      if (itemsEl)
        itemsEl.innerHTML = hasItems
          ? `${this.fmt(t.giftValue)}<small>${t.giftUnits} item${t.giftUnits === 1 ? '' : 's'}${requests ? ` + ${requests} request${requests === 1 ? '' : 's'}` : ''}</small>`
          : '\u2014';
      set('[data-cgc-t-per]', hasItems ? this.fmt(t.productsTotal) : '\u2014');
      set('[data-cgc-t-gifts]', this.state.mode ? t.recipients.toLocaleString() : '\u2014');
      set('[data-cgc-t-total]', hasItems ? this.fmt(t.total) : '\u2014');
      const detail = [];
      if (hasItems) {
        if (t.addonsTotal) detail.push(`${this.fmt(t.addonsTotal)} finishing touches`);
        if (this.state.mode) detail.push(`${this.fmt(t.shipping)} shipping`);
      }
      set(
        '[data-cgc-t-detail]',
        !hasItems ? '' : this.state.mode ? `Includes ${detail.join(' \u00b7 ')}` : 'Priced for one gift. Enter your recipients in step three to see the full order.'
      );
      this.renderLadder(t);

      const dockCount = this.$('[data-cgc-dock-count]');
      if (dockCount) {
        const prev = dockCount.textContent;
        dockCount.textContent = String(t.giftUnits + (t.items.length - t.goods.length));
        if (prev !== dockCount.textContent && !reduceMotion.matches) {
          const box = dockCount.parentElement;
          box.classList.remove('is-bump');
          void box.offsetWidth;
          box.classList.add('is-bump');
        }
      }
      set('[data-cgc-dock-title]', this.submitted ? 'Inquiry sent' : t.discount ? `You're saving ${this.fmt(t.discount)}` : hasItems ? 'Your gift box' : 'Your gift box is empty');
      const dockTitle = this.$('[data-cgc-dock-title]');
      if (dockTitle) dockTitle.classList.toggle('is-saving', !this.submitted && t.discount > 0);
      set(
        '[data-cgc-dock-meta]',
        hasItems
          ? `${this.state.mode ? `${t.recipients.toLocaleString()} gift${t.recipients === 1 ? '' : 's'}` : `${t.giftUnits} item${t.giftUnits === 1 ? '' : 's'} per gift`} \u00b7 ${this.fmt(t.total)}`
          : 'Add a gift to begin'
      );
    }

    savingsText(t) {
      const amount = this.fmt(t.discount);
      const head = String(this.cfg.savingsHeadline || "Boom! You're saving [amount]");
      const sub = String(this.cfg.savingsSubline || '[percent]% volume discount unlocked').replace(/\[percent\]/g, String(t.discountPct));
      const [before, ...rest] = head.split('[amount]');
      const headHtml = rest.length ? `${esc(before)}<span class="cgc-savings__amt">${esc(amount)}</span>${esc(rest.join(amount))}` : `${esc(head)} <span class="cgc-savings__amt">${esc(amount)}</span>`;
      return { headHtml, headText: head.replace(/\[amount\]/g, amount), sub };
    }

    renderLadder(t) {
      const box = this.$('[data-cgc-ladder]');
      if (!box) return;
      const hasItems = t.items.length > 0;
      const min = Number(this.cfg.minimum) || 0;
      const tiers = this.tiers;
      const top = tiers.length ? tiers[tiers.length - 1] : null;
      const slotsEl = this.$('[data-cgc-ladder-slots]');
      if (slotsEl && !slotsEl.childElementCount && tiers.length) {
        slotsEl.innerHTML = tiers
          .map(
            (tr) => `<li class="cgc-slot is-locked" data-min="${tr.min}" data-pct="${tr.pct}">
              <span class="cgc-slot__flag">You're here</span>
              <span class="cgc-slot__pct">${tr.pct}%</span>
              <span class="cgc-slot__min">off ${esc(this.fmt(tr.min).replace(/\.00$/, ''))}+</span>
              <span class="cgc-slot__state" data-cgc-slot-state></span>
            </li>`
          )
          .join('');
      }
      const products = hasItems ? t.productsTotal : 0;
      [...(slotsEl ? slotsEl.children : [])].forEach((li) => {
        const m = Number(li.dataset.min);
        const unlocked = products >= m;
        const current = unlocked && Number(li.dataset.pct) === t.discountPct;
        const wasUnlocked = li.classList.contains('is-unlocked');
        li.classList.toggle('is-unlocked', unlocked);
        li.classList.toggle('is-locked', !unlocked);
        li.classList.toggle('is-current', current);
        if (unlocked && !wasUnlocked && this.ladderReady && !reduceMotion.matches) {
          li.classList.remove('is-flip');
          void li.offsetWidth;
          li.classList.add('is-flip');
        }
        const state = li.querySelector('[data-cgc-slot-state]');
        let away = 'Locked';
        if (hasItems && this.state.mode) away = `${this.fmt(Math.ceil((m - products) / 100) * 100).replace(/\.00$/, '')} away`;
        else if (hasItems && t.giftValue) away = `At ${Math.ceil(m / t.giftValue).toLocaleString()} gifts`;
        if (state) state.textContent = unlocked ? (current ? `Saving ${this.fmt(t.discount)}` : 'Unlocked') : away;
      });
      const fill = this.$('[data-cgc-ladder-fill]');
      const scale = top ? top.min : min || 1;
      if (fill) fill.style.setProperty('--p', clamp(products / scale, 0, 1).toFixed(3));
      box.classList.toggle('is-saving', t.discount > 0);

      const big = this.$('[data-cgc-ladder-big]');
      const kicker = this.$('[data-cgc-ladder-kicker]');
      const msg = this.$('[data-cgc-ladder-msg]');
      if (t.discount > 0) {
        const sv = this.savingsText(t);
        if (kicker) kicker.textContent = `${t.discountPct}% volume discount unlocked`;
        if (big) big.innerHTML = sv.headHtml;
      } else {
        if (kicker) kicker.textContent = 'Volume savings';
        if (big) big.innerHTML = top ? `Save up to <span class="cgc-savings__amt">${top.pct}%</span>` : '';
      }
      if (msg) {
        let text = '';
        if (!hasItems) text = min ? `Corporate orders start at ${this.fmt(min)} in products. Savings start there too.` : 'Add products to start saving.';
        else if (!this.state.mode && t.giftValue && min && products < min)
          text = `Savings apply to your whole order. At ${this.fmt(t.giftValue)} per gift, ${Math.ceil(min / t.giftValue).toLocaleString()} recipients reach the ${this.fmt(min)} minimum.`;
        else if (min && products < min) text = `${this.fmt(min - products)} more in products to reach the ${this.fmt(min)} minimum${tiers[0] && tiers[0].min <= min ? ` and unlock ${tiers[0].pct}% off` : ''}.`;
        else if (t.nextTier) text = `Add ${this.fmt(t.nextTier.min - products)} in products to unlock ${t.nextTier.pct}% off.`;
        else if (t.discountPct) text = "You've unlocked our best rate.";
        msg.textContent = text;
      }

      const prev = this.lastSavingsPct || 0;
      if (t.discountPct !== prev) {
        if (t.discountPct > prev && this.ladderReady) {
          this.announce(`${t.discountPct}% volume discount unlocked. You're saving ${this.fmt(t.discount)}.`);
          this.showUnlock(t);
        }
        this.lastSavingsPct = t.discountPct;
      }
      this.ladderReady = true;
    }

    showUnlock(t) {
      const toast = this.$('[data-cgc-toast]');
      if (!toast || this.submitted) return;
      const pct = this.$('[data-cgc-toast-pct]');
      const sub = this.$('[data-cgc-toast-sub]');
      if (pct) pct.textContent = `${t.discountPct}%`;
      if (sub) sub.textContent = `You're saving ${this.fmt(t.discount)}`;
      const stage = this.stage && this.stage.getBoundingClientRect();
      if (desktop.matches && stage && stage.width) {
        toast.style.left = `${stage.left + stage.width / 2}px`;
        toast.style.top = `${stage.top + stage.height * 0.36}px`;
        toast.style.bottom = 'auto';
        toast.style.translate = '-50% -50%';
      } else {
        toast.style.left = '50%';
        toast.style.top = 'auto';
        toast.style.bottom = 'calc(96px + env(safe-area-inset-bottom, 0px))';
        toast.style.translate = '-50% 0';
      }
      window.clearTimeout(this.toastTimer);
      toast.hidden = false;
      toast.classList.remove('is-in', 'is-out');
      void toast.offsetWidth;
      toast.classList.add('is-in');
      if (desktop.matches) this.confetti(0.05);
      this.toastTimer = window.setTimeout(() => {
        toast.classList.add('is-out');
        this.toastTimer = window.setTimeout(() => {
          toast.hidden = true;
          toast.classList.remove('is-in', 'is-out');
        }, reduceMotion.matches ? 0 : 450);
      }, reduceMotion.matches ? 2600 : 2800);
    }

    renderPanels() {
      const s = this.state;
      const show = { address: s.mode === 'one', list: s.mode === 'many' };
      this.$$('[data-cgc-panel]').forEach((p) => {
        p.hidden = !show[p.dataset.cgcPanel];
      });
      if (this.noteFields) this.noteFields.classList.toggle('is-off', !s.noteOn);
      if (this.countEl && this.messageEl) this.countEl.textContent = String(this.messageEl.value.length);
    }

    renderHints(t) {
      const sel = this.$('[data-cgc-hint="select"]');
      if (sel) {
        const min = Number(this.cfg.minimum) || 0;
        sel.textContent = !t.items.length
          ? ''
          : `${t.giftUnits} item${t.giftUnits === 1 ? '' : 's'} per gift \u00b7 ${this.fmt(t.giftValue)} each${this.state.mode ? ` \u00b7 ${this.fmt(t.productsTotal)} for ${t.recipients.toLocaleString()} recipient${t.recipients === 1 ? '' : 's'}` : ''}${min && t.productsTotal >= min ? ' \u00b7 meets the corporate minimum' : ''}`;
        sel.classList.add('cgc-step__hint--ok');
      }
      const touches = this.$('[data-cgc-hint="touches"]');
      if (touches) {
        touches.innerHTML = this.hasAddonKind('note') && !(this.state.noteOn && this.state.message.trim()) ? 'You chose a handwritten note. <a class="cgc-link" href="#cgc-step-note">Add your message</a> so we know what to write.' : '';
      }
    }

    stepComplete(step, t) {
      const s = this.state;
      if (step === 'select') return t.items.length > 0;
      if (step === 'note') return !s.noteOn || !!s.message.trim();
      if (step === 'recipients') return !!s.mode && (!this.dateField || !!s.date);
      if (step === 'touches') return !!(this.visited && this.visited.has('touches'));
      if (step === 'tie') return this.submitted;
      return false;
    }

    renderRail(t) {
      this.$$('[data-cgc-rail]').forEach((a) => {
        const step = a.dataset.cgcRail;
        a.classList.toggle('is-active', step === this.step);
        a.classList.toggle('is-done', step !== this.step && this.stepComplete(step, t));
        if (step === this.step) a.setAttribute('aria-current', 'step');
        else a.removeAttribute('aria-current');
      });
    }

    occasionOption() {
      return (this.occasionOptions || []).find((x) => x.id === this.state.occasion) || null;
    }

    occasionLabel() {
      const o = this.occasionOption();
      return o ? o.label : '';
    }

    occasionValueId() {
      const o = this.occasionOption();
      if (!o) return null;
      return o.extra ? o.mapsTo : o.id;
    }

    hasAddress() {
      return Object.values(this.address).some((v) => v && v !== 'United States');
    }

    addressLine() {
      const a = this.address;
      const cityLine = [a.city, [a.province, a.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      return [a.fullName, a.address1, a.address2, cityLine, a.country].filter(Boolean).join(', ');
    }

    formatDate(ymd) {
      if (!ymd) return '';
      const [y, m, d] = ymd.split('-').map(Number);
      return new Date(y, m - 1, d).toLocaleDateString(this.cfg.locale || undefined, { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' });
    }

    renderReview(t) {
      const el = this.$('[data-cgc-review]');
      if (!el) return;
      const s = this.state;
      const edit = (step) => `<a class="cgc-link" href="#cgc-step-${step}">Edit</a>`;
      const missing = (text) => `<span class="cgc-review__missing">${esc(text)}</span>`;
      const items = t.items.length
        ? `<ul>${t.items
            .map((i) =>
              i.interest
                ? `<li><em>Request:</em> ${esc(i.title)}</li>`
                : `<li>${i.qty} \u00d7 ${esc(i.title)}${i.variantTitle && i.variantTitle !== 'Default Title' ? ` <em>(${esc(i.variantTitle)})</em>` : ''}</li>`
            )
            .join('')}</ul>`
        : missing('Nothing selected yet');
      const occasion = this.occasionLabel();
      const note = s.noteOn && s.message.trim() ? `${occasion ? `<em>${esc(occasion)} \u00b7</em> ` : ''}\u201c${esc(s.message.trim())}\u201d${s.signoff ? `<br><em>\u2014 ${esc(s.signoff)}</em>` : ''}` : `${occasion ? `<em>${esc(occasion)} \u00b7</em> ` : ''}No note`;
      let recipients;
      if (s.mode === 'one') recipients = this.hasAddress() ? `One recipient <em>\u00b7 ${esc(this.addressLine())}</em>` : 'One recipient <em>\u00b7 address to follow</em>';
      else if (s.mode === 'many')
        recipients = `${s.count.toLocaleString()} recipients <em>\u00b7 ${this.file ? `list attached${this.fileInfo && this.fileInfo.rows ? ` (${this.fileInfo.rows} rows)` : ''}` : 'list to follow'}</em>`;
      else recipients = missing('Enter how many recipients');
      if (this.dateField) recipients += `<br>${s.date ? `Arriving by <em>${esc(this.formatDate(s.date))}</em>` : missing('Choose an arrival date')}`;
      const touches = Object.keys(s.addons).map((id) => this.addons[id]).filter(Boolean);
      let touchHtml = touches.length ? touches.map((a) => `${esc(a.title)} <em>(${esc(a.priceLabel)})</em>`).join('<br>') : 'None';
      if (t.bagIncluded) touchHtml = `${touches.length ? `${touchHtml}<br>` : ''}Gift bag with ribbon <em>(included with your gift set)</em>`;
      const rows = [
        ['Each gift', items, 'select'],
        ['Note', note, 'note'],
        ['Recipients', recipients, 'recipients'],
        ['Touches', touchHtml, 'touches']
      ];
      let html = rows.map(([k, v, step]) => `<div class="cgc-review__row"><span class="cgc-review__key">${k}</span><div class="cgc-review__val">${v}</div>${this.submitted ? '' : edit(step)}</div>`).join('');
      if (this.cfg.showEstimate && t.items.length) {
        const r = t.recipients.toLocaleString();
        const line = (label, sub, amount, cls = '') => `<div class="cgc-est__row${cls}"><dt>${label}${sub ? `<small>${sub}</small>` : ''}</dt><dd>${amount}</dd></div>`;
        let est = line('Products', `${this.fmt(t.giftValue)} per gift \u00d7 ${r} recipient${t.recipients === 1 ? '' : 's'}`, this.fmt(t.productsTotal));
        if (t.addonsTotal) est += line('Finishing touches', `${this.fmt(t.addonEach)} \u00d7 ${r} recipient${t.recipients === 1 ? '' : 's'}`, this.fmt(t.addonsTotal));
        est += s.mode ? line('Shipping', esc(t.shippingLabel), this.fmt(t.shipping)) : line('Shipping', 'Added once you enter recipients', '\u2014');
        if (t.discountPct) {
          const sv = this.savingsText(t);
          est += `<div class="cgc-est__save"><dt><strong>${sv.headHtml}</strong><small>${t.discountPct}% volume discount on products</small></dt><dd>\u2212${this.fmt(t.discount)}</dd></div>`;
        }
        est += line('Estimated total', '', this.fmt(t.total), ' is-total');
        html += `<div class="cgc-review__row cgc-review__est"><span class="cgc-review__key">Estimate</span><dl class="cgc-est">${est}</dl><span></span></div>`;
      }
      el.innerHTML = html;
    }

    save() {
      if (this.submitted) return;
      window.clearTimeout(this.saveTimer);
      this.saveTimer = window.setTimeout(() => {
        const s = this.state;
        local.set(this.storeKey, {
          items: s.items,
          order: s.order,
          occasion: s.occasion,
          noteOn: s.noteOn,
          message: s.message,
          signoff: s.signoff,
          mode: s.mode,
          count: s.count,
          date: s.date,
          addons: s.addons,
          savedAt: Date.now()
        });
      }, 250);
    }

    restore() {
      const saved = local.get(this.storeKey);
      if (!saved || Date.now() - (saved.savedAt || 0) > 1000 * 60 * 60 * 24 * 21) return;
      const s = this.state;
      (saved.order || []).forEach((id) => {
        const p = this.products.get(id);
        const it = saved.items && saved.items[id];
        if (!p || !it) return;
        const select = p.card.querySelector('[data-cgc-variant]');
        if (select && it.variantId && [...select.options].some((o) => o.value === String(it.variantId))) {
          select.value = String(it.variantId);
          const opt = select.options[select.selectedIndex];
          p.variantId = opt.value;
          p.variantTitle = opt.text;
          p.price = Number(opt.dataset.price) || p.price;
          const priceEl = p.card.querySelector('[data-cgc-price]');
          if (priceEl) priceEl.textContent = this.fmt(p.price);
        }
        s.items[id] = { ...it, title: p.title, image: p.image, available: p.available, variantId: p.variantId, variantTitle: p.variantTitle, price: p.interest ? 0 : p.price };
        s.order.push(id);
      });
      ['occasion', 'noteOn', 'message', 'signoff', 'mode', 'count', 'date'].forEach((k) => {
        if (saved[k] !== undefined && saved[k] !== null) s[k] = saved[k];
      });
      Object.keys(saved.addons || {}).forEach((id) => {
        if (this.addons[id]) s.addons[id] = true;
      });
      if (s.date && s.date < todayYmd()) s.date = '';
      if (s.occasion && !this.occasionOption()) s.occasion = null;
      this.applyStateToInputs();
    }

    applyStateToInputs() {
      const s = this.state;
      if (this.messageEl) this.messageEl.value = s.message;
      if (this.signoffEl) this.signoffEl.value = s.signoff;
      if (this.noteOnEl) this.noteOnEl.checked = s.noteOn;
      this.$$('[data-cgc-occasion-opt]').forEach((r) => {
        r.checked = r.value === s.occasion;
      });
      if (this.countInput) this.countInput.value = s.count ? String(s.count) : '';
      if (this.dateEl) this.dateEl.value = s.date;
      this.$$('[data-cgc-addon]').forEach((i) => {
        i.checked = !!s.addons[i.dataset.cgcAddon];
      });
    }

    validate(t) {
      const errors = [];
      const s = this.state;
      const add = (message, target, el) => {
        errors.push({ message, target });
        if (el) el.setAttribute('aria-invalid', 'true');
      };
      if (!t.items.length) add('Add at least one gift to your box.', 'cgc-step-select');
      const messageField = this.fieldFor('message');
      const wantsHandwritten = this.hasAddonKind('note');
      if ((messageField && messageField.required) || wantsHandwritten) {
        if (!(s.noteOn && s.message.trim())) add(wantsHandwritten ? 'Add the message for your handwritten note.' : 'Add your gift message.', this.messageEl ? this.messageEl.id : 'cgc-step-note', this.messageEl);
      }
      if (!s.mode) add('Enter how many recipients will receive this gift.', this.countInput ? this.countInput.id : 'cgc-step-recipients', this.countInput);
      if (s.mode === 'one' && this.hasAddress()) {
        const missing = ADDRESS_REQUIRED.filter((k) => !this.address[k]);
        if (missing.length) {
          const first = this.$(`[data-cgc-addr="${missing[0]}"]`);
          missing.forEach((k) => {
            const input = this.$(`[data-cgc-addr="${k}"]`);
            if (input) input.setAttribute('aria-invalid', 'true');
          });
          add("Finish the recipient's address, or clear it to share it with us later.", first ? first.id : 'cgc-step-recipients');
        }
      }
      if (this.dateField) {
        if (this.dateField.required && !s.date) add('Choose when the gifts should arrive.', this.dateEl ? this.dateEl.id : 'cgc-step-recipients', this.dateEl);
        else if (s.date && s.date < todayYmd()) add('Choose an arrival date in the future.', this.dateEl ? this.dateEl.id : 'cgc-step-recipients', this.dateEl);
      }
      this.roles
        .filter((r) => !SPECIAL_ROLES.includes(r.role))
        .forEach(({ field: f }) => {
          if (this.unsupported.includes(f)) return;
          const v = this.values[f.id];
          const el = this.$(`[data-cgc-field="${CSS.escape(f.id)}"]`);
          const target = `cgc-f-${this.sid}-${f.id}`;
          const empty = v === undefined || v === null || v === false || (typeof v === 'string' && !v.trim()) || (Array.isArray(v) && !v.length);
          if (f.required && empty) add(`${f.label} is required.`, target, el);
          else if (!empty && f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim())) add('Enter a valid email address.', target, el);
        });
      if (this.unsupported.some((f) => f.required)) add('Part of this inquiry needs the classic form. Please use the classic inquiry form below.', 'cgc-step-tie');
      return errors;
    }

    showErrors(errors) {
      if (!this.errorsEl) return;
      if (!errors.length) {
        this.errorsEl.hidden = true;
        this.errorsEl.innerHTML = '';
        return;
      }
      this.errorsEl.hidden = false;
      this.errorsEl.innerHTML = `<strong>Almost there. A few things need your attention:</strong><ul>${errors
        .map((e) => `<li><a href="#${esc(e.target)}" data-cgc-goto="${esc(e.target)}">${esc(e.message)}</a></li>`)
        .join('')}</ul>`;
      this.errorsEl.setAttribute('tabindex', '-1');
      this.errorsEl.focus({ preventScroll: true });
      this.errorsEl.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
    }

    formatValue(f, raw) {
      if (f.type === 'date') return raw || null;
      if (f.type === 'dropdown' || f.type === 'radioButtons') return (f.options || []).find((o) => o.id === raw) || null;
      if (f.type === 'multipleChoice') return (f.options || []).filter((o) => (raw || []).includes(o.id));
      if (f.type === 'checkbox') return !!raw;
      if (raw === undefined || raw === null) return null;
      const str = String(raw).trim();
      return str === '' ? null : str;
    }

    bundleLabel(t) {
      const label = t.items.map((i) => (i.interest ? `Request: ${i.title}` : `${i.qty}x ${i.title}`)).join('; ');
      return label.length > 250 ? `${label.slice(0, 247)}...` : label;
    }

    buildSummary(t) {
      const s = this.state;
      const lines = ['CORPORATE GIFT ORDER (each recipient receives one gift with the items below)'];
      t.items.forEach((i) => {
        if (i.interest) lines.push(`- Request: ${i.title}`);
        else
          lines.push(
            `- ${i.qty} x ${i.title}${i.variantTitle && i.variantTitle !== 'Default Title' ? ` (${i.variantTitle})` : ''} @ ${this.fmt(i.price)}${t.recipients > 1 ? ` (${(i.qty * t.recipients).toLocaleString()} total)` : ''}${i.available === false ? ' [currently sold out - reserve]' : ''}`
          );
      });
      lines.push(`Gift value: ${this.fmt(t.giftValue)} per gift`);
      const touches = Object.keys(s.addons).map((id) => this.addons[id]).filter(Boolean);
      lines.push(`Finishing touches: ${touches.length ? touches.map((a) => `${a.title} (${a.priceLabel})`).join('; ') : 'None'}`);
      if (t.bagIncluded) lines.push('Gift bag: included with the gift set');
      if (this.occasionLabel()) lines.push(`Occasion: ${this.occasionLabel()}`);
      lines.push(`Gift note: ${s.noteOn && s.message.trim() ? 'Yes - see gift message' : 'No'}`);
      const contact = `${this.address.email ? ` | ${this.address.email}` : ''}${this.address.phone ? ` | ${this.address.phone}` : ''}`;
      if (s.mode === 'one') {
        lines.push('Recipients: 1');
        lines.push(`Ship to: ${this.hasAddress() ? this.addressLine() : 'address to follow'}${contact}`);
      } else if (s.mode === 'many') {
        const listNote = this.file ? `list attached${this.fileInfo && this.fileInfo.rows ? ` (${this.fileInfo.rows} rows)` : ''}` : 'list to follow';
        lines.push(`Recipients: ${s.count} addresses - ${listNote} (same gift for everyone unless the list says otherwise)`);
      }
      if (this.uploadFailed) lines.push('NOTE: The recipient file upload failed. Please ask the customer to resend their list.');
      const min = Number(this.cfg.minimum) || 0;
      lines.push('ESTIMATE');
      lines.push(`Products: ${this.fmt(t.giftValue)} x ${t.recipients} gift${t.recipients === 1 ? '' : 's'} = ${this.fmt(t.productsTotal)}${min && t.productsTotal < min ? ` (below ${this.fmt(min)} minimum)` : ''}`);
      if (t.addonsTotal) lines.push(`Finishing touches: ${this.fmt(t.addonEach)} x ${t.recipients} recipients = ${this.fmt(t.addonsTotal)}`);
      lines.push(`Shipping: ${s.mode ? `${t.shippingLabel} = ${this.fmt(t.shipping)}` : 'not calculated'}`);
      if (t.discountPct) lines.push(`Volume discount: ${t.discountPct}% off products = -${this.fmt(t.discount)}`);
      lines.push(`Estimated total: ${this.fmt(t.total)}`);
      if (this.utm) lines.push(`Source: ${Object.entries(this.utm).map(([k, v]) => `${k}=${v}`).join(' ')}`);
      lines.push('Submitted via the corporate gifting page on pappyco.com');
      return lines.join('\n');
    }

    async upload(file) {
      const tokenRes = await fetch(`/apps/${this.s2m.proxy}/proxy/upload-token`, { method: 'POST' });
      if (!tokenRes.ok) throw new Error('Upload token request failed');
      const { url, token } = await tokenRes.json();
      const put = await fetch(url, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
      if (!put.ok) throw new Error('Upload failed');
      const ext = file.name.split('.').pop() || '';
      return { importFileToken: token, importFileName: `import-${Math.random().toString(36).substring(2, 15)}.${ext}` };
    }

    singleRecipientFile(t) {
      const headers = (this.s2m.importFormat.headers || []).filter((h) => !h.exclude);
      const a = this.address;
      const map = { fullName: a.fullName, email: a.email, phone: a.phone, address1: a.address1, address2: a.address2, city: a.city, province: a.province, zip: a.zip, country: a.country, product: this.bundleLabel(t) };
      const csv = [headers.map((h) => csvCell(h.raw)).join(','), headers.map((h) => csvCell(map[h.value] || '')).join(',')].join('\r\n');
      return new File([csv], 'recipient.csv', { type: 'text/csv' });
    }

    buildPayload(t, importData, rows, importError) {
      const raw = {};
      const special = {
        items: this.buildSummary(t),
        message: this.state.noteOn && this.state.message.trim() ? `${this.state.message.trim()}${this.state.signoff ? `\n— ${this.state.signoff}` : ''}` : null,
        occasion: this.occasionValueId(),
        date: this.state.date || null
      };
      this.roles.forEach(({ field: f, role }) => {
        raw[f.id] = role in special ? special[role] : this.values[f.id];
      });
      const inputData = {};
      this.s2m.fields.forEach((f, index) => {
        if (f.type === 'import') return;
        const base = { label: f.label, type: f.type, required: f.required, formOrder: index };
        if (f.storageType) {
          base.storageType = f.storageType;
          if (f.storageType !== 'notes' && f.storageKey) base.storageKey = f.storageKey;
          if (f.type === 'date' && f.storageDateFormat) base.storageDateFormat = f.storageDateFormat;
        }
        if (f.conditionalField && raw[f.conditionalField] !== f.conditionalFieldValue) {
          inputData[f.id] = { ...base, value: null, isConditionallyHidden: true, conditionalField: f.conditionalField, conditionalFieldValue: f.conditionalFieldValue };
          return;
        }
        inputData[f.id] = { ...base, value: this.formatValue(f, raw[f.id]) };
      });
      const pageData = this.s2m.pageData
        ? { ...this.s2m.pageData, url: window.location.href }
        : {
            path: window.location.pathname,
            origin: window.location.origin,
            page_type: 'page',
            template: this.cfg.template || 'page',
            page_title: this.cfg.pageTitle || document.title,
            url: window.location.href,
            locale: this.cfg.locale || 'en',
            settingsInstanceId: this.s2m.instance
          };
      const analyticsToken = window.s2mShopifyUniqToken || safe(() => window.ShopifyAnalytics.lib.user().traits().uniqToken) || null;
      const payload = {
        formData: { inputData },
        pageData,
        loggedInCustomer: this.s2m.customer || null,
        rowsUploaded: rows || 0,
        shopifyAnalyticsToken: analyticsToken
      };
      if (this.importField && this.s2m.importFormat && this.s2m.importFormat.id) payload.importFormat = { _link: this.s2m.importFormat.id };
      if (importData && importData.importFileToken) {
        payload.importFile = { directUploadToken: importData.importFileToken, fileName: importData.importFileName };
        if (importError) payload.importFileError = importError;
      }
      return payload;
    }

    async submit(e) {
      e.preventDefault();
      if (this.submitting || this.submitted) return;
      const t = this.totals();
      const errors = this.validate(t);
      this.showErrors(errors);
      if (errors.length) {
        this.track('cg_concierge_validation_error', { count: errors.length });
        return;
      }
      this.submitting = true;
      const btn = this.$('[data-cgc-submit]');
      const label = this.$('[data-cgc-submit-label]');
      const original = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Tying it off…';
      this.uploadFailed = false;
      try {
        let importData = null;
        let rows = 0;
        let importError = null;
        if (this.importField) {
          let file = null;
          if (this.state.mode === 'one' && this.hasAddress()) {
            file = this.singleRecipientFile(t);
            rows = 1;
          } else if (this.state.mode === 'many' && this.file) {
            file = this.file;
            rows = (this.fileInfo && this.fileInfo.rows) || 0;
            importError = (this.fileInfo && this.fileInfo.error) || null;
          }
          if (file) {
            try {
              importData = await this.upload(file);
            } catch (err) {
              this.uploadFailed = true;
              rows = 0;
              importError = null;
              importData = null;
            }
          }
        }
        const payload = this.buildPayload(t, importData, rows, importError);
        const res = await fetch(`/apps/${this.s2m.proxy}/proxy/inquiry-submit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error(`Inquiry submit failed: ${res.status}`);
        this.onSuccess(t);
      } catch (err) {
        console.error('[Gift concierge]', err);
        if (this.errorsEl) {
          this.errorsEl.hidden = false;
          this.errorsEl.innerHTML = `<strong>We couldn't send your inquiry.</strong> Please try again in a moment.${this.classicSection ? ' You can also <button type="button" class="cgc-link" data-cgc-open-classic>use the classic inquiry form</button>.' : ''}`;
          const openClassic = this.errorsEl.querySelector('[data-cgc-open-classic]');
          if (openClassic) openClassic.addEventListener('click', () => this.toggleClassic(true));
          this.errorsEl.focus({ preventScroll: true });
        }
        this.track('cg_concierge_submit_error', {});
      } finally {
        this.submitting = false;
        if (btn) btn.disabled = false;
        if (label) label.textContent = original;
      }
    }

    onSuccess(t) {
      this.submitted = true;
      local.del(this.storeKey);
      this.track('cg_concierge_inquiry_submitted', {
        value: Math.round(t.total) / 100,
        products_value: Math.round(t.productsTotal) / 100,
        discount_percent: t.discountPct,
        currency: this.cfg.currency || 'USD',
        recipients: t.recipients,
        mode: this.state.mode,
        units: t.units,
        items: t.items.length,
        content_name: 'Corporate Gifting Inquiry',
        content_ids: t.goods.map((i) => String(i.id))
      });
      const after = this.s2m.after || FALLBACK_S2M.after;
      const heading = this.$('[data-cgc-success-heading]');
      const body = this.$('[data-cgc-success-body]');
      if (heading && after.messageHeading) heading.textContent = after.messageHeading;
      if (body && after.messageBody && !body.hasAttribute('data-cgc-own')) body.textContent = after.messageBody;
      const tie = this.$('[data-cgc-tie]');
      const success = this.$('[data-cgc-success]');
      if (tie) tie.hidden = true;
      if (success) {
        success.hidden = false;
        success.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        success.focus({ preventScroll: true });
      }
      const wasTied = this.scene && this.scene.dataset.tied === 'true';
      this.update();
      this.confetti(wasTied ? 0.15 : 2.2);
      if (!desktop.matches && this.stage && this.dock) window.setTimeout(() => this.toggleSheet(true), 500);
      if (after.action === 'redirect' && after.redirectUrl) window.setTimeout(() => window.location.assign(after.redirectUrl), 2600);
    }

    confetti(delay = 0.15) {
      const holder = this.$('[data-cgc-confetti]');
      if (!holder || reduceMotion.matches) return;
      const colors = ['#e6b10e', '#f6ebd8', '#df7357', '#cabe96', '#faccad'];
      holder.innerHTML = '';
      for (let i = 0; i < 36; i++) {
        const piece = document.createElement('i');
        const angle = (Math.PI * 2 * i) / 36 + Math.random() * 0.4;
        const dist = 120 + Math.random() * 160;
        piece.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
        piece.style.setProperty('--dy', `${Math.sin(angle) * dist - 60}px`);
        piece.style.setProperty('--rot', `${Math.round(Math.random() * 720 - 360)}deg`);
        piece.style.setProperty('--c', colors[i % colors.length]);
        piece.style.animationDelay = `${delay + Math.random() * 0.25}s`;
        piece.style.opacity = '0';
        holder.appendChild(piece);
      }
      window.setTimeout(() => {
        holder.innerHTML = '';
      }, 4600);
    }

    restart() {
      this.submitted = false;
      this.state = this.freshState();
      this.address = {};
      this.values = {};
      this.clearFile();
      this.$$('[data-cgc-addr]').forEach((i) => {
        i.value = i.dataset.cgcAddr === 'country' ? 'United States' : '';
        if (i.value) this.address[i.dataset.cgcAddr] = i.value;
      });
      if (this.form) this.form.reset();
      this.renderContact();
      this.applyStateToInputs();
      const tie = this.$('[data-cgc-tie]');
      const success = this.$('[data-cgc-success]');
      if (tie) tie.hidden = false;
      if (success) success.hidden = true;
      this.showErrors([]);
      this.toggleSheet(false);
      this.update();
      const first = document.getElementById('cgc-step-select');
      if (first) first.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  }

  customElements.define('cg-concierge', CgConcierge);
})();
